import React from 'react'

const TermsCondition = () => {
  return (
    <div>TermsCondition</div>
  )
}

export default TermsCondition